module.exports = __webpack_public_path__ + "static/media/IconEditProfileMobile.bf533bad.svg";